var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TelegramLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.56222 11.593L15.288 18.3906C15.3773 18.4697 15.4856 18.5242 15.6023 18.5487C15.719 18.5732 15.8401 18.567 15.9536 18.5306C16.0672 18.4942 16.1693 18.4288 16.25 18.341C16.3307 18.2532 16.3871 18.1459 16.4138 18.0297L19.645 3.91877C19.6721 3.79725 19.6657 3.67065 19.6265 3.55249C19.5872 3.43433 19.5166 3.32904 19.4222 3.24786C19.3278 3.16669 19.2131 3.11268 19.0904 3.09159C18.9677 3.07051 18.8416 3.08314 18.7255 3.12815L2.86144 9.35862C2.22551 9.60784 2.31144 10.536 2.98176 10.6735L7.56222 11.593Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5625 11.5929L19.2586 3.14526",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4211 14.9875L8.73984 17.6688C8.64419 17.7659 8.52181 17.8324 8.38828 17.8599C8.25474 17.8873 8.11606 17.8744 7.98987 17.8228C7.86368 17.7712 7.75567 17.6833 7.67958 17.5702C7.60348 17.4571 7.56273 17.3239 7.5625 17.1875V11.593",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegramLogo.b0564c3fe616f8f8add1dd0af58658be.svg";
export { ForwardRef as ReactComponent };